import data from 'emojibase-data/en/data.json';
import messages from 'emojibase-data/en/messages.json';

export type SkinTone = 0 | 1 | 2 | 3 | 4 | 5;
export type EmojiOption = { emoji: string, name: string, searchText: string };
type EmojiWithSkins = EmojiOption & { skins: Partial<Record<SkinTone, EmojiOption>> };
type EmojiCategory = { id: string, name: string, emojis: EmojiWithSkins[] };

export const skinTones: { tone: SkinTone, emoji: string, name: string }[] = [
    {tone: 0, emoji: '🖐️', name: 'Default skin tone'},
    {tone: 1, emoji: '🖐🏻', name: 'Light skin tone'},
    {tone: 2, emoji: '🖐🏼', name: 'Medium-light skin tone'},
    {tone: 3, emoji: '🖐🏽', name: 'Medium skin tone'},
    {tone: 4, emoji: '🖐🏾', name: 'Medium-dark skin tone'},
    {tone: 5, emoji: '🖐🏿', name: 'Dark skin tone'},
];

export const emojiCategories: EmojiCategory[] = messages.groups
    .map(group => ({
        id: group.key,
        name: group.message,
        emojis: data
            // Ungrouped regional indicators are flag components, not standalone emojis.
            .filter(emoji =>
                emoji.group === group.order &&
                messages.subgroups
                    .find(subgroup => subgroup.order === emoji.subgroup)
                    ?.key !== 'skin-tone'
            )
            .map(emoji => {
                const searchText = [
                    emoji.emoji,
                    emoji.label,
                    group.message,
                    messages.subgroups
                        .find(subgroup => subgroup.order === emoji.subgroup)
                        ?.message,
                    ...(emoji.tags || []),
                ].join(' ').toLowerCase();
                const skins: EmojiWithSkins['skins'] = {};
                for (const {tone} of skinTones) {
                    const variant = emoji.skins
                        ?.find(skin =>
                            Array.isArray(skin.tone)
                                ? skin.tone.every(value => value === tone)
                                : skin.tone === tone
                        );
                    if (variant) {
                        skins[tone] = {
                            emoji: variant.emoji,
                            name: variant.label,
                            searchText: `${searchText} ${variant.emoji} ${variant.label}`.toLowerCase(),
                        };
                    }
                }
                return {emoji: emoji.emoji, name: emoji.label, searchText, skins};
            }),
    }))
    .filter(category => category.emojis.length > 0);

export function emojiWithSkinTone(emoji: EmojiWithSkins, tone: SkinTone): EmojiOption {
    return emoji.skins[tone] || emoji;
}
